import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import SortAscIcon from '../../../assets/svg/icono-ordenar-asc.svg';
import SortDescIcon from '../../../assets/svg/icono-ordenar-desc.svg';
import { PaqueteBitacora } from '../../../interfaces/Prestaciones.interface';
import PackageHistoryTimelineRow from './PackageHistoryTimelineRow';

interface PackageHistoryTimelineProps {
  events: PaqueteBitacora[];
}

const PackageHistoryTimeline = ({ events }: PackageHistoryTimelineProps) => {
  const [orderDate, setOrderDate] = useState<'ASC' | 'DESC'>('DESC');

  const sorted = orderDate === 'DESC' ? events : [...events].reverse();

  return (
    <Box id="timeline">
      <Grid container justifyContent="flex-end">
        <Grid item xs={4} md={3}>
          <p onClick={() => setOrderDate(o => o === 'DESC' ? 'ASC' : 'DESC')} className="order-field">
            Fecha{' '}
            {orderDate === 'DESC'
              ? <span><img alt="desc" src={SortDescIcon} /></span>
              : <span><img alt="asc" src={SortAscIcon} /></span>
            }
          </p>
        </Grid>
      </Grid>

      {sorted.map((event, idx) => (
        <PackageHistoryTimelineRow
          key={event.id}
          event={event}
          color={idx % 2 === 0 ? 'blue' : 'dark-blue'}
        />
      ))}
    </Box>
  );
};

export default PackageHistoryTimeline;
